import SectionCard from '@/components/base/SectionCard';
import StatusBadge from '@/components/base/StatusBadge';
import type { CreatorProfile } from '@/types/portal';
import { formatMoney } from '@/utils/format';

export default function VettingPanel({ creator }: { creator: CreatorProfile }) {
  const checks = [
    { label: 'Identity verification', value: creator.verification, icon: 'ri-shield-user-line' },
    { label: 'KYC status', value: creator.kycStatus, icon: 'ri-file-shield-2-line' },
    { label: 'Wallet', value: creator.walletStatus, icon: 'ri-wallet-3-line' },
    { label: 'Brand safety', value: creator.brandSafety, icon: 'ri-shield-check-line' },
  ];

  return (
    <SectionCard title="Vetting & compliance" subtitle="Before this creator can be contracted">
      <div className="space-y-2">
        {checks.map((check) => (
          <div
            key={check.label}
            className="flex items-center justify-between gap-2 rounded-md border border-background-200 px-3 py-2.5"
          >
            <span className="inline-flex items-center gap-2 text-sm text-foreground-700">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className={check.icon} />
              </span>
              {check.label}
            </span>
            <StatusBadge status={check.value} />
          </div>
        ))}
      </div>

      <div className="mt-4 rounded-md bg-background-100 px-3 py-3">
        <div className="flex items-center justify-between">
          <span className="text-sm text-foreground-600">Estimated rate</span>
          <span className="font-heading text-base font-semibold text-foreground-900">
            {creator.rate != null ? formatMoney(creator.rate, creator.currency) : '—'}
          </span>
        </div>
        <p className="mt-1 text-[11px] text-foreground-500">
          Typical response time: {creator.responseTime}
        </p>
      </div>

      {creator.riskFlags.length > 0 ? (
        <div className="mt-3 rounded-md border border-primary-200 bg-primary-50 px-3 py-3">
          <p className="inline-flex items-center gap-1.5 text-xs font-label font-semibold text-primary-800">
            <i className="ri-alert-line" />
            {creator.riskFlags.length} item(s) need resolution
          </p>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {creator.riskFlags.map((flag) => (
              <StatusBadge key={flag} status={flag} />
            ))}
          </div>
        </div>
      ) : null}
    </SectionCard>
  );
}